
const FavouriteStores = () => {
  return (
    <>
      <div className=" display-max">
        <div className=" d-flex justify-content-between align-items-end pb-2">
          <div
            className=" w-100 cursor-pointer"
            id="v-pills-fav-store-1-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-fav-store-1"
            role="tab"
            aria-controls="v-pills-fav-store-1"
            aria-selected="true"
          >
            <div className=" d-flex justify-content-start align-items-center gap-3">
              <div className="border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                  <img
                    alt=""
                    src="../../assets/img/stores/store-1.png"
                    className="avatar "
                    style={{}}
                  />
                </div>
              </div>
              <div className=" mt-2">
                <b className=" text-sm fw-bolder text-black">
                  Amazon
                  <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                </b>
                <div className=" lh-0">
                  <b className=" tetx-black fw-normal text-xs">
                    Lorem ipsum dolor sit amet consectetur Autem, adipisicing
                    elit. Autem accusantium facere!
                  </b>
                </div>
                <div className=" lh-1">
                  <b className=" tetx-black fw-bolder text-xxs">
                    Tue 02 Sep 2025 1:30:10 PM
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div className=" w-15 text-center">
            <div>
              <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                <div
                  id="storeOptions"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                </div>
                <ul className="dropdown-menu" aria-labelledby="storeOptions">
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Pin
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Mute
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Unsubscribe
                    </a>
                  </li>
                </ul>
              </li>
            </div>
          </div>
        </div>
        <hr className=" horizontal dark" />
        <div className=" d-flex justify-content-between align-items-end pb-2">
          <div
            className=" w-100 cursor-pointer"
            id="v-pills-fav-store-1-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-fav-store-1"
            role="tab"
            aria-controls="v-pills-fav-store-1"
            aria-selected="true"
          >
            <div className=" d-flex justify-content-start align-items-center gap-3">
              <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                  <img
                    alt=""
                    src="../../assets/img/stores/store-2.png"
                    className="avatar "
                  />
                </div>
              </div>
              <div className=" mt-2">
                <b className=" text-sm fw-bolder text-black">
                  Flipkart
                  <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                </b>
                <div className=" lh-0">
                  <b className=" tetx-black fw-normal text-xs">
                    Lorem ipsum dolor sit amet consectetur Autem, adipisicing
                    elit. Autem accusantium facere!
                  </b>
                </div>
                <div className=" lh-1">
                  <b className=" tetx-black fw-bolder text-xxs">
                    Tue 02 Sep 2025 1:30:10 PM
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div className=" w-15 text-center">
            <div>
              <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                <div
                  id="storeOptions"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                </div>
                <ul className="dropdown-menu" aria-labelledby="storeOptions">
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Pin
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Mute
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Unsubscribe
                    </a>
                  </li>
                </ul>
              </li>
            </div>
          </div>
        </div>
        <hr className=" horizontal dark" />
        <div className=" d-flex justify-content-between align-items-end pb-2">
          <div
            className=" w-100 cursor-pointer"
            id="v-pills-fav-store-1-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-fav-store-1"
            role="tab"
            aria-controls="v-pills-fav-store-1"
            aria-selected="true"
          >
            <div className=" d-flex justify-content-start align-items-center gap-3">
              <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                  <img
                    alt=""
                    src="../../assets/img/stores/store-3.png"
                    className="avatar "
                  />
                </div>
              </div>
              <div className=" mt-2">
                <b className=" text-sm fw-bolder text-black">
                  Myntra
                  <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                </b>
                <div className=" lh-0">
                  <b className=" tetx-black fw-normal text-xs">
                    Lorem ipsum dolor sit amet consectetur Autem, adipisicing
                    elit. Autem accusantium facere!
                  </b>
                </div>
                <div className=" lh-1">
                  <b className=" tetx-black fw-bolder text-xxs">
                    Tue 02 Sep 2025 1:30:10 PM
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div className=" w-15 text-center">
            <div>
              <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                <div
                  id="storeOptions"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                </div>
                <ul className="dropdown-menu" aria-labelledby="storeOptions">
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Pin
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Mute
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Unsubscribe
                    </a>
                  </li>
                </ul>
              </li>
            </div>
          </div>
        </div>
        <hr className=" horizontal dark" />
        <div className=" d-flex justify-content-between align-items-end pb-2">
          <div
            className=" w-100 cursor-pointer"
            id="v-pills-fav-store-1-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-fav-store-1"
            role="tab"
            aria-controls="v-pills-fav-store-1"
            aria-selected="true"
          >
            <div className=" d-flex justify-content-start align-items-center gap-3">
              <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                  <img
                    alt=""
                    src="../../assets/img/stores/store-4.png"
                    className="avatar "
                  />
                </div>
              </div>
              <div className=" mt-2">
                <b className=" text-sm fw-bolder text-black">
                  Ajio
                  <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                </b>
                <div className=" lh-0">
                  <b className=" tetx-black fw-normal text-xs">
                    Lorem ipsum dolor sit amet consectetur Autem, adipisicing
                    elit. Autem accusantium facere!
                  </b>
                </div>
                <div className=" lh-1">
                  <b className=" tetx-black fw-bolder text-xxs">
                    Tue 02 Sep 2025 1:30:10 PM
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div className=" w-15 text-center">
            <div>
              <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                <div
                  id="storeOptions"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                </div>
                <ul className="dropdown-menu" aria-labelledby="storeOptions">
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Pin
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Mute
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Unsubscribe
                    </a>
                  </li>
                </ul>
              </li>
            </div>
          </div>
        </div>
        <hr className=" horizontal dark" />
        <div className=" d-flex justify-content-between align-items-end pb-2">
          <div
            className=" w-100 cursor-pointer"
            id="v-pills-fav-store-1-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-fav-store-1"
            role="tab"
            aria-controls="v-pills-fav-store-1"
            aria-selected="true"
          >
            <div className=" d-flex justify-content-start align-items-center gap-3">
              <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                  <img
                    alt=""
                    src="../../assets/img/stores/store-5.png"
                    className="avatar "
                  />
                </div>
              </div>
              <div className=" mt-2">
                <b className=" text-sm fw-bolder text-black">
                  Nyka
                  <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                </b>
                <div className=" lh-0">
                  <b className=" tetx-black fw-normal text-xs">
                    Lorem ipsum dolor sit amet consectetur Autem, adipisicing
                    elit. Autem accusantium facere!
                  </b>
                </div>
                <div className=" lh-1">
                  <b className=" tetx-black fw-bolder text-xxs">
                    Tue 02 Sep 2025 1:30:10 PM
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div className=" w-15 text-center">
            <div>
              <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                <div
                  id="storeOptions"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                </div>
                <ul className="dropdown-menu" aria-labelledby="storeOptions">
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Pin
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Mute
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Unsubscribe
                    </a>
                  </li>
                </ul>
              </li>
            </div>
          </div>
        </div>
        <hr className=" horizontal dark" />
        <div className=" d-flex justify-content-between align-items-end pb-2">
          <div
            className=" w-100 cursor-pointer"
            id="v-pills-fav-store-1-tab"
            data-bs-toggle="pill"
            data-bs-target="#v-pills-fav-store-1"
            role="tab"
            aria-controls="v-pills-fav-store-1"
            aria-selected="true"
          >
            <div className=" d-flex justify-content-start align-items-center gap-3">
              <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                  <img
                    alt=""
                    src="../../assets/img/stores/store-6.png"
                    className="avatar "
                  />
                </div>
              </div>
              <div className=" mt-2">
                <b className=" text-sm fw-bolder text-black">
                  Indiamart
                  <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                </b>
                <div className=" lh-0">
                  <b className=" tetx-black fw-normal text-xs">
                    Lorem ipsum dolor sit amet consectetur Autem, adipisicing
                    elit. Autem accusantium facere!
                  </b>
                </div>
                <div className=" lh-1">
                  <b className=" tetx-black fw-bolder text-xxs">
                    Tue 02 Sep 2025 1:30:10 PM
                  </b>
                </div>
              </div>
            </div>
          </div>
          <div className=" w-15 text-center">
            <div>
              <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                <div
                  id="storeOptions"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                </div>
                <ul className="dropdown-menu" aria-labelledby="storeOptions">
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Pin
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Mute
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item fw-bold text-black" href="/">
                      Unsubscribe
                    </a>
                  </li>
                </ul>
              </li>
            </div>
          </div>
        </div>
      </div>
      <div className=" display-minni display-mob">
        <div>
          <div className=" d-flex justify-content-between align-items-end pb-2">
            <div
              className=" w-100 cursor-pointer"
            >
              <a href="/channel-view">
                <div className=" d-flex justify-content-start align-items-center gap-3">
                  <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                    <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                      <img
                        alt=""
                        src="../../assets/img/stores/store-1.png"
                        className="avatar "
                      />
                    </div>
                  </div>
                  <div className=" mt-2">
                    <b className=" text-sm fw-bolder text-black">
                      Amazon
                      <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                    </b>
                    <div className=" lh-0">
                      <b className=" tetx-black fw-normal text-xs">
                        Lorem ipsum dolor sit amet consectetur Autem,
                        adipisicing elit. Autem accusantium facere!
                      </b>
                    </div>
                    <div className=" lh-1">
                      <b className=" tetx-black fw-bolder text-xxs">
                        Tue 02 Sep 2025 1:30:10 PM
                      </b>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className=" w-15 text-center">
              <div>
                <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                  <div
                    id="storeOptions"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                  </div>
                  <ul className="dropdown-menu" aria-labelledby="storeOptions">
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Pin
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Mute
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Unsubscribe
                      </a>
                    </li>
                  </ul>
                </li>
              </div>
            </div>
          </div>
          <hr className=" horizontal dark" />
          <div className=" d-flex justify-content-between align-items-end pb-2">
            <div className=" w-100">
              <a href="/channel-view">
                <div className=" d-flex justify-content-start align-items-center gap-3">
                  <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                    <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                      <img
                        alt=""
                        src="../../assets/img/stores/store-2.png"
                        className="avatar "
                      />
                    </div>
                  </div>
                  <div className=" mt-2">
                    <b className=" text-sm fw-bolder text-black">
                      Flipkart
                      <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                    </b>
                    <div className=" lh-0">
                      <b className=" tetx-black fw-normal text-xs">
                        Lorem ipsum dolor sit amet consectetur Autem,
                        adipisicing elit. Autem accusantium facere!
                      </b>
                    </div>
                    <div className=" lh-1">
                      <b className=" tetx-black fw-bolder text-xxs">
                        Tue 02 Sep 2025 1:30:10 PM
                      </b>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className=" w-15 text-center">
              <div>
                <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                  <div
                    id="storeOptions"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                  </div>
                  <ul className="dropdown-menu" aria-labelledby="storeOptions">
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Pin
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Mute
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Unsubscribe
                      </a>
                    </li>
                  </ul>
                </li>
              </div>
            </div>
          </div>
          <hr className=" horizontal dark" />
          <div className=" d-flex justify-content-between align-items-end pb-2">
            <div className=" w-100">
              <a href="/channel-view">
                <div className=" d-flex justify-content-start align-items-center gap-3">
                  <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                    <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                      <img
                        alt=""
                        src="../../assets/img/stores/store-3.png"
                        className="avatar avatar-custom ms-n2 mt-n2 p-3"
                      />
                    </div>
                  </div>
                  <div className=" mt-2">
                    <b className=" text-sm fw-bolder text-black">
                      Myntra
                      <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                    </b>
                    <div className=" lh-0">
                      <b className=" tetx-black fw-normal text-xs">
                        Lorem ipsum dolor sit amet consectetur Autem,
                        adipisicing elit. Autem accusantium facere!
                      </b>
                    </div>
                    <div className=" lh-1">
                      <b className=" tetx-black fw-bolder text-xxs">
                        Tue 02 Sep 2025 1:30:10 PM
                      </b>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className=" w-15 text-center">
              <div>
                <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                  <div
                    id="storeOptions"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                  </div>
                  <ul className="dropdown-menu" aria-labelledby="storeOptions">
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Pin
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Mute
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Unsubscribe
                      </a>
                    </li>
                  </ul>
                </li>
              </div>
            </div>
          </div>
          <hr className=" horizontal dark" />
          <div className=" d-flex justify-content-between align-items-end pb-2">
            <div className=" w-100">
              <a href="/channel-view">
                <div className=" d-flex justify-content-start align-items-center gap-3">
                  <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                    <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                      <img
                        alt=""
                        src="../../assets/img/stores/store-4.png"
                        className="avatar "
                      />
                    </div>
                  </div>
                  <div className=" mt-2">
                    <b className=" text-sm fw-bolder text-black">
                      Ajio
                      <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                    </b>
                    <div className=" lh-0">
                      <b className=" tetx-black fw-normal text-xs">
                        Lorem ipsum dolor sit amet consectetur Autem,
                        adipisicing elit. Autem accusantium facere!
                      </b>
                    </div>
                    <div className=" lh-1">
                      <b className=" tetx-black fw-bolder text-xxs">
                        Tue 02 Sep 2025 1:30:10 PM
                      </b>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className=" w-15 text-center">
              <div>
                <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                  <div
                    id="storeOptions"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                  </div>
                  <ul className="dropdown-menu" aria-labelledby="storeOptions">
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Pin
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Mute
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Unsubscribe
                      </a>
                    </li>
                  </ul>
                </li>
              </div>
            </div>
          </div>
          <hr className=" horizontal dark" />
          <div className=" d-flex justify-content-between align-items-end pb-2">
            <div className=" w-100">
              <a href="/channel-view">
                <div className=" d-flex justify-content-start align-items-center gap-3">
                  <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                    <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                      <img
                        alt=""
                        src="../../assets/img/stores/store-5.png"
                        className="avatar "
                      />
                    </div>
                  </div>
                  <div className=" mt-2">
                    <b className=" text-sm fw-bolder text-black">
                      Nyka
                      <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                    </b>
                    <div className=" lh-0">
                      <b className=" tetx-black fw-normal text-xs">
                        Lorem ipsum dolor sit amet consectetur Autem,
                        adipisicing elit. Autem accusantium facere!
                      </b>
                    </div>
                    <div className=" lh-1">
                      <b className=" tetx-black fw-bolder text-xxs">
                        Tue 02 Sep 2025 1:30:10 PM
                      </b>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className=" w-15 text-center">
              <div>
                <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                  <div
                    id="storeOptions"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                  </div>
                  <ul className="dropdown-menu" aria-labelledby="storeOptions">
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Pin
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Mute
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Unsubscribe
                      </a>
                    </li>
                  </ul>
                </li>
              </div>
            </div>
          </div>
          <hr className=" horizontal dark" />
          <div className=" d-flex justify-content-between align-items-end pb-2">
            <div className=" w-100">
              <a href="/channel-view">
                <div className=" d-flex justify-content-start align-items-center gap-3">
                  <div className=" border-radius-2xl border" style={{width:"100px" , height:"51px" ,borderRadius:"50%" }}>
                    <div className="text-center  " style={{width:"48px" , height:"48px" ,borderRadius:"50%" }}>
                      <img
                        alt=""
                        src="../../assets/img/stores/store-6.png"
                        className="avatar "
                      />
                    </div>
                  </div>
                  <div className=" mt-2">
                    <b className=" text-sm fw-bolder text-black">
                      Indiamart
                      <i className="bi bi-patch-check-fill text-info fs-6 ms-1"></i>
                    </b>
                    <div className=" lh-0">
                      <b className=" tetx-black fw-normal text-xs">
                        Lorem ipsum dolor sit amet consectetur Autem,
                        adipisicing elit. Autem accusantium facere!
                      </b>
                    </div>
                    <div className=" lh-1">
                      <b className=" tetx-black fw-bolder text-xxs">
                        Tue 02 Sep 2025 1:30:10 PM
                      </b>
                    </div>
                  </div>
                </div>
              </a>
            </div>
            <div className=" w-15 text-center">
              <div>
                <li className="avatar avatar-sm border-radius-2xl bg-gray-100 dropdown">
                  <div
                    id="storeOptions"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-three-dots opacity-7 fs-5 text-black"></i>
                  </div>
                  <ul className="dropdown-menu" aria-labelledby="storeOptions">
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Pin
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Mute
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item fw-bold text-black" href="/">
                        Unsubscribe
                      </a>
                    </li>
                  </ul>
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FavouriteStores;
